import _flatMap from 'lodash/flatMap';
import _values from 'lodash/values';
import _difference from 'lodash/difference';

export const filterNarrativesForContent = (narratives, contentId) => {
  const id = parseInt(contentId, 10);
  const filteredLinks = {};
  Object.keys(narratives).forEach((key) => {
    filteredLinks[key] = narratives[key].filter((item) => {
      return item.links.map((link) => link.id).includes(id);
    });
  });
  return filteredLinks;
};

export const contentIsLinked = (narrativeLinks, linkedId) => {
  if (narrativeLinks && narrativeLinks.length && linkedId) {
    return narrativeLinks.some(
      (link) =>
        link.id &&
        link.id.toString() === linkedId.toString() &&
        link.linked !== false
    );
  }
  return false;
};

export const getLinksFromNarratives = (
  narratives,
  contentId,
  lastSelectedKFA = null
) => {
  const links = [];
  if (narratives) {
    Object.keys(narratives).forEach((key) => {
      narratives[key].forEach((narrative) => {
        if (key === 'hypotheses' && lastSelectedKFA) {
          if (narrative.contentId === lastSelectedKFA) {
            links.push(narrative.contentId);
          }
        }
        narrative.links.forEach((link) => {
          if (link.linked !== false && link.id === contentId) {
            if (key === 'hypotheses' && lastSelectedKFA) {
              if (narrative.contentId === lastSelectedKFA) {
                links.push(narrative.contentId);
              }
            } else {
              links.push(narrative.contentId);
            }
          }
        });
      });
    });
  }
  const uniqueLinks = [...new Set(links)];
  return uniqueLinks;
};

export const getTopicLinksForContent = (
  narratives,
  existingContentLinks = []
) => {
  const narrativeLinks = _flatMap(_values(narratives), (contentArray) =>
    contentArray.map((c) => c.contentId)
  );
  const existingLinks = existingContentLinks.map((c) => c.id);
  const topicLinks = _difference(existingLinks, narrativeLinks);

  return topicLinks;
};
